var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-container"},[_c('purchase-modal',{attrs:{"invoice-style":_vm.invoiceStyle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }